<template>
  <div class="member-container">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="button-wrapper"
      :class="{ selected: index === activeIndex }"
    >
      <button
        :title="item.label"
        class="member-button"
        :class="{
          'protectedIdentity-color': item.protectedIdentity || item.legalRef
        }"
        @click="$emit('selectItemIndex', index)"
      >
        <span class="member-button-text"
          >{{ item.label
          }}<LegalIcon
            v-if="item.legalRef"
            color="#e00201"
            height="16"
            width="16"
        /></span>
      </button>
      <div class="shadow"></div>
    </div>
  </div>
</template>
<script>
import LegalIcon from '@/components/Icons/LegalIcon.vue';

export default {
  name: 'MemberSelector',
  components: { LegalIcon },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number,
      required: true
    }
  },
  emits: ['selectItemIndex']
};
</script>
<style scoped>
.member-container {
  display: flex;
  margin-top: 0.5rem;
}

.button-wrapper {
  width: 100%;
  z-index: 0;
  position: relative;
  margin-bottom: -1px;
}

.member-button {
  box-shadow: none;
  border: none;
  padding: 10px 8px 11px;
  font-weight: bold;
  color: #222;
  font-size: 14px;
  cursor: pointer;
  text-transform: capitalize;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border: 1px solid transparent;
  border-bottom: none;
  width: 100%;
  background-color: #f8f8fa;
}

.shadow {
  content: '';
  position: absolute;
  background-color: #f8f8fa;
  height: 20px;
  bottom: -1px;
  right: 0;
  left: 0;
  z-index: -1;
  transform: translateY(100%);
}

.member-button:nth-child(1),
.member-button:nth-child(1) + .shadow {
  opacity: 0.9;
}

.member-button:nth-child(2),
.member-button:nth-child(2) + .shadow {
  opacity: 0.8;
}

.member-button:nth-child(3),
.member-button:nth-child(3) + .shadow {
  opacity: 0.7;
}

.button-wrapper.selected {
  z-index: 2;
}

.button-wrapper.selected .member-button {
  opacity: 1;
  border-color: var(--active-card-border);
  z-index: 2;
}

.button-wrapper.selected .shadow {
  display: none;
}

.member-button-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
</style>
